<template>
  <div class="p_market_module p_hunt_module">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">企业</div>
            <el-input
              v-model="listQuery.strEntName"
              size="small"
              clearable
              @keyup.enter.native="searchHandle"
            ></el-input>
          </div>
          <div class="screenInput">
            <div class="flname">岗位</div>
            <el-input
              v-model="listQuery.strJobName"
              size="small"
              clearable
              @keyup.enter.native="searchHandle"
            ></el-input>
          </div>
          <div class="screenInput">
            <el-tooltip
              class="scr_icon"
              effect="dark"
              content="高级检索项"
              placement="top-start"
            >
              <i class="i_txt" @click="dropDownScreen"
                >{{ showDropScreen == 1 ? "收起" : "更多"
                }}<i class="el-icon-caret-bottom"></i
              ></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button
          v-if="showDropScreen == -1"
          :disabled="isSearchHandle"
          type="success"
          size="small"
          @click="searchHandle"
          :style="!isNull(tableData) ? '' : 'margin-right:16px'"
          style="margin-right: 15px"
          >搜索</el-button
        >
        <!-- <el-button v-if="tableData.length>0" type="warning" plain size="small" @click="exportHandle" :loading="btnLoading" style="margin-right:16px">导出</el-button> -->
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form
          :inline="true"
          :model="listQuery"
          class="re_down_form"
          label-width="94px"
        >
          <el-form-item label="来源:">
            <el-select
              v-model="listQuery.strplatform"
              size="small"
              placeholder=""
              clearable
            >
              <el-option
                v-for="(item, index) in platformList"
                :key="index + 'b'"
                :label="item.strplatform"
                :value="item.strplatform"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地区:" class="th_input_label">
            <el-input
              v-model="listQuery.strAddr"
              size="small"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="企业规模:" label-width="68px">
            <el-select
              v-model="listQuery.StrEntScale"
              size="small"
              placeholder=""
              clearable
            >
              <el-option
                v-for="(item, index) in scaleList"
                :key="index + 'b'"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="招聘单位类型:">
            <el-select filterable v-model="listQuery.strEnttype" placeholder="" size="small" clearable>
              <el-option v-for="(item,index) in typeList" :key="index+'c'" :label="item.Basname" :value="item.Basname"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="行业:">
            <el-input
              v-model="listQuery.StrEntIndustry"
              size="small"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="年薪:" class="th_input_label th_input_label03">
            <div class="l_line_input">
              <el-input
                v-model="listQuery.strSalary01"
                type="number"
                @change="salaryChange01"
                size="small"
                clearable
              ></el-input>
              <!-- <div style="width:40px;">万元</div> -->
              <span> - </span>
              <el-input
                v-model="listQuery.strSalary02"
                type="number"
                @change="salaryChange02"
                size="small"
                clearable
              ></el-input>
              <div style="width: 40px">万元</div>
            </div>
            <!-- <el-select v-model="listQuery.StrSalary" size="small" placeholder="" clearable>
              <el-option v-for="(item,index) in salaryList" :key="index+'o'" :label="item.text" :value="item.val"></el-option>
            </el-select> -->
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1"
          >关闭</el-button
        >
        <el-button
          :disabled="isSearchHandle"
          size="small"
          type="success"
          @click="searchHandle()"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>营销雷达</el-breadcrumb-item>
          <el-breadcrumb-item>线索查看</el-breadcrumb-item>
          <el-breadcrumb-item>猎头线索雷达</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_clue_box">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            label="CRM雷达监测"
            name="second"
            :disabled="tableLoading"
          ></el-tab-pane>
          <el-tab-pane
            label="线索雷达监测"
            name="third"
            v-if="isCanViewClue"
            :disabled="tableLoading"
          ></el-tab-pane>
          <el-tab-pane
            label="猎头线索雷达"
            name="four"
            v-if="isCanViewHunt"
            :disabled="tableLoading"
          ></el-tab-pane>
        </el-tabs>
        <el-table
          ref="clueTable"
          class="re_table"
          border
          v-loading="tableLoading"
          @sort-change="sortHandle"
          :highlight-current-row="true"
          :max-height="tableHeight - 100"
          :data="tableData"
          style="width: 100%"
        >
          <template v-for="(item, index) in tableTitle">
            <el-table-column
              :prop="item.StrColumId"
              :fixed="
                item.StrColumId == 'StrQue' ||
                item.StrColumId == 'StrEntNice' ||
                item.StrColumId == 'StrJobName'
              "
              :sortable="item.StrColumName == '缺口' ? 'custom' : false"
              :label="item.StrColumName"
              fit
              :show-overflow-tooltip="
                item.StrColumName == '联系人' ? false : true
              "
              :key="index"
              v-if="item.StrColumName != '联系方式'"
              :min-width="
                item.StrColumName.indexOf('序号') > -1
                  ? '60px'
                  : item.StrColumName.indexOf('全称') > -1
                  ? '250px'
                  : item.StrColumName.indexOf('简称') > -1 ||
                    item.StrColumName.indexOf('时间') > -1 ||
                    item.StrColumName.indexOf('公海') > -1
                  ? '160px'
                  : item.StrColumName.indexOf('缺口') > -1
                  ? '72px'
                  : '100px'
              "
              align="center"
            >
              <template slot-scope="scope">
                <span
                  v-if="item.StrColumId == 'StrSource'"
                  title="点击可跳转详情"
                  @click="jumpOtherNet(scope.row.StrNation)"
                  class="j_url_txt"
                  >{{
                    isNull(scope.row[item.StrColumId])
                      ? ""
                      : scope.row[item.StrColumId]
                  }}</span
                >
                <span
                  class="contacts cp"
                  v-else-if="item.StrColumName == '联系人'"
                >
                  <el-popover
                    placement="left"
                    :width="isContactsByOther ? 150 : 641"
                    trigger="click"
                    :ref="`popover-${scope.row.StrQue}`"
                  >
                    <el-table
                      v-show="!isContactsByOther"
                      :data="contactsList"
                      v-loading="contactsLoading"
                      border
                      class="p_pop_box"
                    >
                      <el-table-column
                        width="100"
                        property="name"
                        label="姓名"
                        fit
                        :show-overflow-tooltip="true"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        width="120"
                        property="tel"
                        label="联系方式"
                        fit
                        :show-overflow-tooltip="true"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        width="120"
                        property="source"
                        label="来源"
                        fit
                        :show-overflow-tooltip="true"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        width="150"
                        label="时间"
                        fit
                        :show-overflow-tooltip="true"
                        align="center"
                      >
                        <template slot-scope="{ row }">
                          <span>{{
                            isNull(row.DtInsertDate)
                              ? ""
                              : row.DtInsertDate.replace("T", " ")
                          }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        width="150"
                        property="remark"
                        label="备注"
                        fit
                        :show-overflow-tooltip="true"
                        align="center"
                      ></el-table-column>
                    </el-table>
                    <div v-show="isContactsByOther">
                      <div class="confirmTitle">查询联系方式</div>
                      <div class="btnBox flex">
                        <div
                          class="confirmBtn cp"
                          @click="confirmGetentContactnumbyother(scope.$index)"
                        >
                          确定
                        </div>
                        <div class="cancelBtn cp" @click="cancel(scope.row)">
                          取消
                        </div>
                      </div>
                    </div>
                    <img
                      v-if="scope.row.haveTel == 1"
                      src="../../assets/images/contacts.png"
                      alt=""
                      slot="reference"
                      @click="getentcontactnum(scope.row)"
                      title="查看联系人及联系方式"
                    />
                    <img
                      v-if="scope.row.haveTel == 0"
                      src="../../assets/images/seach.png"
                      alt=""
                      slot="reference"
                      @click="getentContactnumbyother(scope.row)"
                      title="天眼查获取联系人及联系方式"
                    />
                  </el-popover>
                </span>
                <span v-else>{{
                  isNull(scope.row[item.StrColumId])
                    ? ""
                    : scope.row[item.StrColumId]
                }}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column label="操作" width="200px" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="
                  checkPermission(['headHunting_add_contacts'], permissionLists)
                "
                type="success"
                size="mini"
                @click="addContacts(scope.row)"
                >添加联系人</el-button
              >
              <el-button
                v-if="
                  isNull(scope.row.StrClaimName) &&
                  checkPermission(['headHunting_claim'], permissionLists)
                "
                type="primary"
                size="mini"
                @click="claimHandle(scope.row)"
                >认领</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.currpage"
            :page-size="listQuery.perpage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100, 200]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="确定下载" :visible.sync="downVisible" width="450px">
      <div style="font-size: 14px">请确认，是否下载导出数据？</div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="downVisible = false">取消</button>
        <button
          class="search"
          @click="confirmDown"
          style="margin-left: 10px; font-weight: 600"
        >
          确定
        </button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加联系人"
      :visible.sync="addContactsVisible"
      width="450px"
    >
      <div class="formBox">
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="联系人" prop="telpername">
            <el-input v-model="form.telpername"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="telNum">
            <el-input v-model="form.telNum"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="addContactsVisible = false">取消</button>
        <button
          class="search"
          @click="confirmAddContacts"
          style="margin-left: 10px; font-weight: 600"
        >
          确定
        </button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import xz from "../../common";
import checkPermission from "@/utils/permission"; // 权限判断函数
export default {
  data() {
    return {
      custPath: "",
      tablePath: this.$store.state.EMP.tablePath,
      scaleList: ["200人以上", "500人以上", "2000人以上", "5000人以上"],
      salaryList: [
        {
          text: "30万-50万",
          val: "30-50",
        },
        {
          text: "50万-80万",
          val: "50-80",
        },
        {
          text: "80万-100万",
          val: "80-100",
        },
        {
          text: "100万-150万",
          val: "100-150",
        },
        {
          text: "150万-200万",
          val: "150-200",
        },
        {
          text: "200万以上",
          val: "200以上",
        },
        {
          text: "面议",
          val: "面议",
        },
      ],
      contactsList: [], //联系人列表
      contactsLoading: false,
      isContactsByOther: false, //是否是从其他渠道取联系方式
      info: {}, //点击按钮行的数据
      downVisible: false,
      btnLoading: false,
      activeName: "",
      tableHeight: 0,
      showDropScreen: -1,
      tableData: [],
      // 认领
      claimQuery: {
        EntId: "", //企业id
        StrClaimName: "", //名字
        StrClaimtel: "", //手机号
        StrClaimuserid: "", //认领人ID
      },
      // 客户线索参数
      listQuery: {
        strEntName: "", //公司名称
        strEnttype: "", //公司区分
        strJobName: "", //岗位名称
        StrEntScale: "", //企业规模
        StrSalary: "", //年薪
        strAddr: "", //地区
        StrEntIndustry: "", //行业
        strplatform: "", //采集平台
        strTableId: "",
        dtReleasetimepx: "", //更新时间排序 desc降序 asc升序
        JobNumpx: "", //缺口排序 desc降序 asc升序
        roletype: localStorage.loginRoletype,
        strSalary01: "",
        strSalary02: "",
        AddTelFollow: "",
        currpage: 1,
        perpage: 10,
      },
      // 导出参数
      exportQuery: {
        strEntName: "", //公司名称
        strEnttype: "", //公司区分
        strJobName: "", //岗位名称
        strAddr: "", //地区
        strplatform: "", //采集平台
        strTableId: "",
        dtReleasetimepx: "", //更新时间排序 desc降序 asc升序
        JobNumpx: "", //缺口排序 desc降序 asc升序
        roletype: localStorage.loginRoletype,
        currpage: 1,
        perpage: 1000000,
      },
      isSearchHandle: false,
      tableLoading: false,
      // 表头数据
      tableTitle: [],
      total: 0,
      // 任务列表
      taskList: [],
      taskQuery: {
        currpage: 1,
        perpage: 10,
        strplatform: "", //平台
        strTaskname: "",
      },
      // 采集平台
      platformList: [],
      platformQuery: {
        currpage: 1,
        perpage: 100,
        i_keyword: "", //关键字
        strStatus: "", //状态 2
      },
      basicQuery: {
        keyword: "strEnttype", //strEnttype 单位类型
        currpage: 1,
        perpage: 10000,
      },
      // 招聘单位类型
      typeList: [],
      loginRoletype: localStorage.loginRoletype,
      addContactsVisible: false,
      form: {
        EntId: "",
        telNum: "",
        telpername: "",
        remark: "",
      },
      rules: {
        telpername: {
          required: true,
          message: "请输入联系人姓名",
          trigger: "blur",
        },
        telNum: { required: true, message: "请输入联系方式", trigger: "blur" },
      },
      // 按钮权限参数
      butQuery: {
        path: "/marketingRadar",
        powerEnName: "product",
      },
      permissionLists: [],
      // 是否能看线索雷达
      isCanViewClue:false,
      // 是否能看猎头
      isCanViewHunt:false
    };
  },
  created() {
    this.calHeight();
    this.getTabsPower();
    // 获取任务列表
    this.getTaskList();
    // 获取采集平台列表
    this.getPlatformList();
    // 获取基础信息
    // this.getBasicList();
    this.getDtlRoletype();
  },
  methods: {
    checkPermission,
    // 获取按钮权限
    getButtonPower() {
      xz.getbtnPowerIdBypage(this.butQuery).then((res) => {
        // console.log('按钮',res)
        if (res.status == "ok") {
          let resmsg = res.msg;
          if (!this.isNull(resmsg)) {
            for (let index = 0; index < resmsg.length; index++) {
              let element = resmsg[index];
              this.permissionLists.push(element.Enname);
            }
          } else {
            this.permissionLists = [];
          }
        } else {
          this.permissionLists = [];
        }
      });
    },
    // 获取tab列表权限
    getTabsPower() {
      let actives = this.$route.query.activeName;
      let query = {
        currpage:1,
        perpage:10
      }
      let that = this
      xz.getpageroleList(query).then((res) => {
        // console.log('tab权限',res)
        if (res.status == "ok") {
          if(res.msg1 == '1'){// 有权限 2无权限
            that.isCanViewClue = true
          }else{
            that.isCanViewClue = false
          }
          if(res.msg2 == '1'){// 有权限 2无权限
            that.isCanViewHunt = true
          }else{
            that.isCanViewHunt = false
          }
          // 从别的页面跳转过来
          if(!that.isNull(actives)){
            that.activeName = actives
            if((that.isCanViewClue)&&that.activeName == "third"){
              this.$router.push({
                path: "/marketingRadar",
                query: {
                  active: "third",
                },
              });
            }
            if(that.activeName == "second"){
              this.$router.push({
                path: "/marketingRadar",
                query: {
                  active: "second",
                },
              });
            }
            if((that.isCanViewHunt)&&that.activeName == "four"){
              that.listQuery.strTableId = "CFReptJobInf";
              that.getTableTitle(that.listQuery.strTableId);
            }
          }else{
            if(that.isCanViewHunt){
              this.activeName == "four"
              that.listQuery.strTableId = "CFReptJobInf";
              that.getTableTitle(that.listQuery.strTableId);
            }else{
              this.$router.push({
                path: "/marketingRadar",
                query: {
                  active: "second",
                },
              });
            }
          }
        } else {
          this.$router.push({
            path: "/marketingRadar",
            query: {
              active: "second",
            },
          });
        }
        that.getButtonPower(); //按钮权限
      });
    },
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
      // console.log('height', this.tableHeight)
    },
    salaryChange01(val) {
      // console.log('val', val)
      let that = this;
      if (this.isNullNotZero(val)) {
        that.listQuery.StrSalary = "";
      }
    },
    salaryChange02(val) {
      // console.log('val', val)
      let that = this;
      if (
        !this.isNullNotZero(val) &&
        !this.isNullNotZero(that.listQuery.strSalary01)
      ) {
        that.listQuery.StrSalary =
          that.listQuery.strSalary01 + "-" + that.listQuery.strSalary02;
      } else {
        if (this.isNullNotZero(val)) {
          that.listQuery.StrSalary = "";
        }
        if (
          !that.isNullNotZero(val) &&
          that.isNullNotZero(that.listQuery.strSalary01)
        ) {
          that.listQuery.StrSalary = "";
        }
      }
    },
    // 认领
    claimHandle(item) {
      // console.log('item',item)
      this.claimQuery.EntId = item.GdEntId; //企业id
      this.$confirm("是否确定认领?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          xz.addEntClaim(this.claimQuery).then((res) => {
            if (res.status == "ok") {
              this.$message({ type: "success", message: "认领成功" });
              this.getList(this.listQuery);
            } else {
              this.$message({ type: "error", message: res.msg });
            }
          });
        })
        .catch(() => {});
    },
    // 获取登录详情
    getDtlRoletype() {
      let dtlQuery = {
        mainuserid: "",
        useridr: Cookies.get("userid-b"),
      };
      xz.getauthJbUserDetail(dtlQuery).then((res) => {
        // console.log('oo',res)
        if (res.status == "ok") {
          this.claimQuery.StrClaimName = res.msg.Username;
          this.claimQuery.StrClaimtel = res.msg.Strmobile;
          this.claimQuery.StrClaimuserid = res.msg.Userid;
        }
      });
    },
    // 导出
    exportHandle() {
      this.exportQuery = JSON.parse(JSON.stringify(this.listQuery));
      this.exportQuery.currpage = 1;
      this.exportQuery.perpage = 1000000;
      this.btnLoading = true;
      // console.log('ll',param)
      xz.outputEcrmList(this.listQuery.strTableId, this.exportQuery).then(
        (res) => {
          // console.log('ll',res)
          if (res.status == "ok") {
            this.custPath = res.stroutpath;
            this.downVisible = true;
          } else {
            this.$message({
              type: "error",
              message: "导出失败，请稍后再试",
            });
            return false;
          }
          this.btnLoading = false;
        }
      );
    },
    // 确定下载导出数据
    confirmDown() {
      let path = this.tablePath + this.custPath;
      const aTag = document.createElement("a");
      aTag.href = path;
      aTag.click();
      this.downVisible = false;
    },
    handleClick(tab) {
      // console.log('tab', tab)
      this.activeName = tab.name;
      if (this.activeName == "second") {
        // 获取CRM客户线索
        this.$router.push({
          path: "/marketingLead?activeName=second",
        });
      } else if (this.activeName == "third") {
        // 获取潜在客户线索
        this.$router.push({
          path: "/marketingLead?activeName=third",
        });
      }
    },
    // 跳转岗位详情页
    jumpOtherNet(url) {
      // let routeData = this.$router.resolve({ path: '/login',query: {loginName}});
      // window.open(routeData.href, '_blank');

      // let path = window.location.protocol+'//' + url
      // window.location.href = path
      window.open(url, "_blank");
    },
    // 获取列表
    getList() {
      this.tableLoading = true;
      xz.getCusLeadsLists(this.listQuery, "getpotentialLists").then((res) => {
        // console.log('getList', res)
        if (res.status == "ok") {
          this.tableData = res.msg;
          this.total = Number(res.totalcount);
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.tableLoading = false;
      });
    },
    //分页
    handleCurrentChange(val) {
      this.listQuery.currpage = Number(val);
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.currpage = 1;
      this.listQuery.perpage = Number(val);
      this.getList();
    },
    sortHandle(column) {
      //order-- ascending 升序、descending 降序、 null 默认排序
      console.log("oo", this.listQuery, column);
      if (column.prop == "IntJobNum") {
        //缺口
        this.listQuery.dtReleasetimepx = "";
        if (column.order == "ascending") {
          this.listQuery.JobNumpx = "asc";
        } else {
          this.listQuery.JobNumpx = "desc";
        }
      }
      if (column.prop == "DtReleasetime") {
        //更新时间
        this.listQuery.JobNumpx = "";
        if (column.order == "ascending") {
          this.listQuery.dtReleasetimepx = "asc";
        } else {
          this.listQuery.dtReleasetimepx = "desc";
        }
      }
      this.getList();
    },
    // 数据排序
    sortMethod() {
      this.getList();
    },
    // 获取表头
    getTableTitle(strTableId) {
      xz.getEcrmColumnList(strTableId, "").then((res) => {
        // console.log('tableTitle', res)
        if (res.status == "ok") {
          this.tableTitle = res.msg;
          this.getList(this.listQuery);
        } else {
          this.tableTitle = [];
        }
      });
    },
    // 获取任务列表
    getTaskList() {
      xz.getTaskList(this.taskQuery).then((res) => {
        // console.log('taskList', res)
        if (res.status == "ok") {
          this.taskList = res.msg;
        } else {
          this.taskList = [];
        }
      });
    },
    // 获取采集平台列表
    getPlatformList() {
      this.platformList = [];
      xz.getCollectionConfig(this.platformQuery).then((res) => {
        // console.log('platformList', res)
        if (res.status == "ok") {
          for (let index = 0; index < res.msg.length; index++) {
            let element = res.msg[index];
            if (element.strStatus == "2") {
              this.platformList.push(element);
            }
          }
        } else {
          this.platformList = [];
        }
      });
    },
    // 获取基础信息
    getBasicList() {
      xz.getJbBaseBasicdataList(this.basicQuery).then((res) => {
        // console.log('typeList', res)
        if (res.status == "ok") {
          this.typeList = res.msg;
        } else {
          this.typeList = [];
        }
      });
    },
    // 搜索
    searchHandle() {
      let that = this;
      this.listQuery.currpage = 1;
      if (!this.isNullNotZero(that.listQuery.strSalary02)) {
        if (this.isNullNotZero(that.listQuery.strSalary01)) {
          that.listQuery.strSalary01 = 0;
        }
      }
      if (this.isNullNotZero(that.listQuery.strSalary02)) {
        if (!this.isNullNotZero(that.listQuery.strSalary01)) {
          that.listQuery.strSalary02 = 1000;
        }
      }
      if (
        !this.isNullNotZero(that.listQuery.strSalary02) &&
        !this.isNullNotZero(that.listQuery.strSalary01)
      ) {
        that.listQuery.StrSalary =
          that.listQuery.strSalary01 + "-" + that.listQuery.strSalary02;
      }
      this.getList(this.listQuery);
    },
    // 清空
    resetHandle() {
      this.listQuery = this.$options.data.call(this).listQuery;
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1;
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1;
      }
    },
    //判断是否为空(包含0)
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == 0 ||
        o == "null" ||
        o == [] ||
        o == "NaN"
      );
    },
    isNullNotZero(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o === "" ||
        o == "null" ||
        o == "NaN"
      );
    },
    //获取联系人和联系方式
    getentcontactnum(item) {
      this.isContactsByOther = false;
      this.contactsLoading = true;
      xz.getentcontactnum("", item.StrEntNice).then((res) => {
        if (res.status == "ok") {
          this.contactsList = res.data;
        } else {
          this.contactsList = [];
        }
        this.contactsLoading = false;
      });
    },
    getentContactnumbyother(item) {
      this.isContactsByOther = true;
      this.info = item;
    },
    //其他方式取联系方式
    confirmGetentContactnumbyother(index) {
      console.log(index);
      this.$set(this.tableData[index], "haveTel", 1);
      this.isContactsByOther = false;
      let item = this.info;
      this.contactsLoading = true;
      xz.getentContactnumbyother(item.StrEntNice).then((res) => {
        if (res.status == "ok") {
          this.contactsList = res.data;
        } else {
          this.contactsList = [];
        }
        this.contactsLoading = false;
      });
    },
    cancel(scope) {
      this.$refs[`popover-${scope.StrQue}`][0].doClose();
    },
    addContacts(row) {
      this.form = {
        EntId: "",
        telNum: "",
        telpername: "",
        remark: "",
      };
      this.form.EntId = row.GdEntId;
      this.addContactsVisible = true;
    },
    confirmAddContacts() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          xz.addEntcontactnum(this.form).then((res) => {
            if (res.status == "ok") {
              this.$message.success("添加成功！");
              this.getList(this.listQuery);
            } else {
              this.$message.error(res.msg);
            }
            this.addContactsVisible = false;
          });
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.j_url_txt {
  /* color:#67C23A; */
  text-decoration: underline;
  cursor: pointer;
}

.scr_icon.i_txt {
  display: inline-block;
  font-size: 12px;
  cursor: pointer;
}

.main-con {
  background-color: #f3f3f3;
  padding: 0px 15px 15px;
  overflow-x: hidden;
  overflow-y: auto;
}

.r_dropDownScreen {
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #fff;
}

.re_down_form .el-form-item {
  margin-bottom: 3px;
  margin-right: 0;
}

.contacts img {
  width: 24px;
  height: 24px;
}

.confirmTitle {
  padding: 14px 5px;
}

.cancelBtn {
  color: #409eff;
  margin-right: 53px;
}

.confirmBtn {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  width: 55px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 5px;
}

.btnBox {
  width: 100%;
  flex-direction: row-reverse;
  align-items: center;
  font-size: 13px;
}
.formBox {
  width: 360px;
}
</style>
<style>
.p_market_module
  .re_down_form.el-form--inline
  .th_input_label03
  .el-form-item__content {
  width: 300px !important;
}
.p_market_module .l_line_input .el-input {
  width: 97px;
}
.p_market_module .l_line_input {
  display: flex;
  justify-items: center;
}
.p_pop_box.el-table .el-table__cell {
  padding: 3px 0;
}
.p_market_module .el-table .ascending .sort-caret.ascending {
  border-bottom-color: #c0c4cc;
}

.p_market_module .el-table .descending .sort-caret.descending {
  border-top-color: #c0c4cc;
}

.p_market_module .th_input_label .el-form-item__label {
  width: 66px !important;
}

.p_market_module .el-form-item__label {
  padding: 0 5px 0 0;
}

.p_market_module .el-tabs {
  background-color: #fff;
  padding: 0 10px;
}

.p_market_module .screenInputs .screenInput {
  margin: 0 0 10px 5px;
}

.p_market_module .screenInputs .screenInput .el-select .el-input__inner,
.p_market_module .re_down_form.el-form--inline .el-form-item__content,
.p_market_module .re_down_form .el-select,
.p_market_module .re_down_form .el-form-item__content,
.p_market_module .screenInput .el-input {
  width: 200px !important;
}

.re_table.el-table .cell {
  padding: 0 5px;
}

.re_table.el-table .el-table__cell {
  padding: 3px 0;
}

.p_market_module .r_dropDownScreen .el-select .el-input .el-select__caret {
  line-height: 40px;
}
</style>